export default {"src":"/_next/static/media/Gravity_DAO.a78b6fa6.svg","height":194,"width":200,"blurWidth":0,"blurHeight":0};